<template>
  <p class="text-label-1 text-orange-500 font-medium mt-4px" :class="{ 'pl-100px': inline }" v-html="getError()" v-if="error"></p>
</template>

<script>
export default {
  props: {
    error: [String, Array, Object],
    inline: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getError() {
      let error = "";
      if (typeof this.error === "string") {
        error = `${this.error}`;
      } else {
        error = `${this.error.message}`;
        // console.log(this.error)
        // this.error.forEach(err => {
        //   error += `${err}`;
        // });
      }
      return error;
    }
  }
};
</script>